<template>
  <section class="bg-white py-14">
    <div class="max-w-4xl mx-auto px-4">
      <!-- Header -->
      <div class="text-center">
        <h2 class="text-xl font-semibold text-yellow uppercase font-style">
          Frequently Asked Questions
        </h2>
        <p class="mt-4 mb-10 text-gray-700 max-w-2xl mx-auto">
          Learn more about the mission, impact, and programs of Mshel Foundation. These FAQs provide answers to common questions about our outreach initiatives, community support, and how you can engage or benefit from our work.
        </p>
      </div>

      <!-- Filter Buttons -->
      <div class="flex flex-wrap justify-center gap-3 mb-10">
        <button
          v-for="category in categories"
          :key="category"
          @click="selectedCategory = category"
          :class="[
            'px-4 py-1 rounded-full border text-sm font-semibold',
            selectedCategory === category
              ? 'bg-black text-white'
              : 'bg-white text-black border-gray-300 hover:bg-gray-100'
          ]"
        >
          {{ category }}
        </button>
      </div>

      <!-- FAQs -->
      <div class="space-y-4">
        <div
          v-for="(faq, index) in filteredFaqs"
          :key="index"
          class="border border-gray-200 rounded-xl shadow-sm"
        >
          <button
            class="w-full px-5 py-4 bg-gray-50 flex justify-between items-center text-left"
            @click="toggleFAQ(index)"
          >
            <div class="flex items-center gap-3 text-gray-800 font-medium">
              <i class="fas fa-question-circle text-gray-500"></i>
              <span>{{ faq.question }}</span>
            </div>
            <svg
              :class="{ 'rotate-180': faq.open }"
              class="w-5 h-5 text-gray-600 transition-transform duration-300"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
            </svg>
          </button>

          <transition name="faq-slide">
            <div v-if="faq.open" class="px-5 pb-5 text-gray-600">
              {{ faq.answer }}
            </div>
          </transition>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  data() {
    return {
      selectedCategory: "All",
      categories: ["All", "General", "Outreach", "Education"],
      faqs: [
        {
          question: "What does Mshel Foundation focus on?",
          answer:
            "Mshel Foundation focuses on digital education, community empowerment, health outreach, and support for underprivileged groups across Nigeria and beyond.",
          category: "General",
          open: false,
        },
        {
          question: "Who can participate in the Pitch Your Dream Enterprise Challenge?",
          answer:
            "The challenge is open to innovative Nigerian youths seeking funding and mentorship to launch or grow their businesses.",
          category: "Outreach",
          open: false,
        },
        {
          question: "How does the foundation support orphanages?",
          answer:
            "We provide essential resources like food, clothing, educational materials, and basic medical support to orphanages and vulnerable children.",
          category: "Outreach",
          open: false,
        },
        {
          question: "Does Mshel Foundation offer scholarships?",
          answer:
            "Yes, we offer scholarships and support for school infrastructure, digital literacy, and other educational empowerment programs.",
          category: "Education",
          open: false,
        },
        {
          question: "Where is Mshel Foundation located and does it operate beyond Nigeria?",
          answer:
            "Mshel Foundation is headquartered in Nigeria and aims to expand to other African nations and developing regions globally.",
          category: "General",
          open: false,
        },
      ],
    };
  },
  computed: {
    filteredFaqs() {
      if (this.selectedCategory === "All") return this.faqs;
      return this.faqs.filter(faq => faq.category === this.selectedCategory);
    },
  },
  methods: {
    toggleFAQ(index) {
      this.filteredFaqs[index].open = !this.filteredFaqs[index].open;
    },
  },
};
</script>

<style scoped>
.faq-slide-enter-active,
.faq-slide-leave-active {
  transition: max-height 0.3s ease, opacity 0.3s ease;
  overflow: hidden;
}
.faq-slide-enter-from,
.faq-slide-leave-to {
  max-height: 0;
  opacity: 0;
}
.faq-slide-enter-to,
.faq-slide-leave-from {
  max-height: 500px;
  opacity: 1;
}
.font-style {
  font-family: "Edu NSW ACT Cursive", cursive;
}
</style>



